import { render, staticRenderFns } from "./dropdown-custom.vue?vue&type=template&id=57ba458e&scoped=true&"
import script from "./dropdown-custom.vue?vue&type=script&lang=js&"
export * from "./dropdown-custom.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-custom.vue?vue&type=style&index=0&id=57ba458e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ba458e",
  null
  
)

export default component.exports